import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { refresh } = useAuth();
  const nav = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      await refresh();
      toast.success("Welcome back");
      nav("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20">
      <div className="font-mono text-xs uppercase tracking-[0.2em] text-[#525252] mb-4">Sign in</div>
      <h1 className="font-serif text-4xl font-black text-[#0A0A0A] mb-8 tracking-tight">Welcome back.</h1>
      <form onSubmit={onSubmit} className="space-y-5" data-testid="login-form">
        <div>
          <label className="text-xs uppercase tracking-wider text-[#525252] font-medium">Email</label>
          <input
            data-testid="login-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1.5 w-full px-3 py-2.5 border border-[#E5E5E0] focus:border-[#0A0A0A] focus:outline-none bg-transparent"
          />
        </div>
        <div>
          <label className="text-xs uppercase tracking-wider text-[#525252] font-medium">Password</label>
          <input
            data-testid="login-password"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-1.5 w-full px-3 py-2.5 border border-[#E5E5E0] focus:border-[#0A0A0A] focus:outline-none bg-transparent"
          />
        </div>
        <button
          data-testid="login-submit"
          disabled={loading}
          type="submit"
          className="w-full py-3 bg-[#0A0A0A] text-[#FFFFFF] hover:bg-[#000000] disabled:opacity-50 transition-colors font-medium"
        >
          {loading ? "Signing in..." : "Sign in"}
        </button>
      </form>
      <p className="mt-6 text-sm text-[#525252]">
        New here?{" "}
        <Link data-testid="login-to-register" to="/register" className="text-[#0A0A0A] hover:text-[#C5A059] underline underline-offset-4">
          Create an account
        </Link>
      </p>
    </div>
  );
}
